// Import the functions you need from the SDKs
import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Set REACT_APP_USE_EMULATORS=true (in .env.development.local, say) to run the
// app against the Firestore and Auth emulators of a demo project instead of
// the live shop — to try the dashboard on data that can be thrown away. Never
// set in a build that is deployed.
const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCPczKtNvD8ma1-ol2RH21qbC1jY_pvi58",
  authDomain: "ndizachem.firebaseapp.com",
  projectId: useEmulators ? 'demo-crestancia' : "ndizachem",
  storageBucket: "ndizachem.firebasestorage.app",
  messagingSenderId: "848554883026",
  appId: "1:848554883026:web:a9ec5b8c4823fd41347a0b",
  measurementId: "G-JGS76LB224"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);




// Initialize Firebase services
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const functions = getFunctions(app);

if (useEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
}
